import React from 'react'
import { Form } from 'semantic-ui-react'

const BooleanFilter = ({ options, value, onChange, ...props }) => {
  const valueOptions = [
    { value: '', text: 'Vše' },
    { value: 'true', text: options[0] },
    { value: 'false', text: options[1] },
  ]
  const currentValue = value === '' ? value : (value ? 'true' : 'false')
  return (
    <Form.Select
      options={valueOptions}
      value={currentValue}
      onChange={(e, event) => {
        const value = event.value
        if (!value) onChange({ value: '' })
        else onChange({ value: event.value === 'true' })
      }}
      {...props}
    />
  )
}

BooleanFilter.defaultProps = {
  options: ['Ano', 'Ne'],
  value: '',
}

BooleanFilter.propTypes = {
  options: React.PropTypes.array,
  onChange: React.PropTypes.func.isRequired,
  value: React.PropTypes.any,
}

export default (BooleanFilter)



// WEBPACK FOOTER //
// ./src/browser/components/filters/BooleanFilter.js